// Custom hook for managing user authentication state
// Now uses AuthContext to avoid multiple API calls
// DEPRECATED: Import useAuth from context/AuthContext instead

import { useAuth } from "../context/AuthContext";

// Re-export the context hook for backwards compatibility
export default useAuth;
